import { booleanAttribute, Component, Input } from '@angular/core';

@Component({
  selector: 'ui-label',
  standalone: true,
  template: `<ng-content></ng-content>@if (required) {
      <span class="ui-label-required">*</span>
    }`,
  styleUrl: './ui-label.component.scss',
})
export class UiLabelComponent {
  @Input({ transform: booleanAttribute }) required = false;
}
